import { Form, Input, Modal } from 'antd';
import { useCallback, useEffect, type FC } from 'react';

import type {
  PortfolioEditFormValues,
  PortfolioEditModalProps,
} from '@pages/Portfolio/types';

const { useForm, Item } = Form;
const { TextArea } = Input;

export const PortfolioEditModal: FC<PortfolioEditModalProps> = ({
  open,
  confirmLoading,
  portfolio,
  onCancel,
  onSubmit,
  disabled,
}) => {
  const [form] = useForm<PortfolioEditFormValues>();
  const { setFieldsValue, resetFields, submit } = form;

  useEffect(() => {
    setFieldsValue({
      description: portfolio?.Description ?? '',
    });
  }, [setFieldsValue, portfolio]);

  const handleOk = useCallback(() => {
    submit();
  }, [submit]);

  const handleFinish = useCallback(
    async (values: PortfolioEditFormValues) => {
      await onSubmit({
        description: values.description ?? null,
      });
    },
    [onSubmit]
  );

  const afterClose = useCallback(() => {
    resetFields();
  }, [resetFields]);

  return (
    <Modal
      open={open}
      title="Редактирование портфолио"
      okText="Сохранить"
      cancelText="Отмена"
      onOk={handleOk}
      onCancel={onCancel}
      afterClose={afterClose}
      confirmLoading={confirmLoading}
      destroyOnHidden
      className="bc-employee-portfolio-modal"
      okButtonProps={{ disabled }}
      cancelButtonProps={{ disabled }}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Item
          label="Описание"
          name="description"
          className="bc-employee-portfolio-modal__description"
        >
          <TextArea rows={4} maxLength={4000} showCount />
        </Item>
      </Form>
    </Modal>
  );
};
